import React, { useEffect, useState } from "react";
import { fetchAllEventCategories, fetchAllEventCategoriesWithEvents, fetchCategoryEvents } from "../../../Apiservices/Auth/servers/fetchCategoryEvents";
import { useTransition } from "react";
import EventsTable from "./Eventtable";
import Sidebar from "../Sidebar";
import { uploadsmultipleimages_getids,updateEventImage,updateEvencategoryImage} from "../../../Apiservices/Auth/servers/fetchProviderData"; 
import "./Eventsbody.css"
function Eventsbody() {
  const [eventCategories, setEventCategories] = useState([]);
  const [isPending, startTransition] = useTransition();
  const [eventCategoriesWithEvent, setEventCategoriesWithEvent] = useState([]);
  const [uploading, setUploading] = useState(false);
  const [updating, setUpdating] = useState(false);
  const [uploadingCategories, setUploadingCategories] = useState(false);
    const [updatingCategories, setUpdatingCategories] = useState(false);

  const loadEventCategories = async () => {
    startTransition(async () => {
      const response = await fetchAllEventCategoriesWithEvents();
      const events = await fetchCategoryEvents();
      console.log("response", response);
      if (response) {
        setEventCategories(response);
      }
    });
  };

  useEffect(() => {
    loadEventCategories();
  }, []);
  const extractCategoryNameFromFileName = (fileName) => {
    // Remove file extension and any numbers/timestamps
    let categoryName = fileName
      .replace(/\.[^/.]+$/, "") // Remove file extension
      .replace(/[-_]\d+$/, "") // Remove trailing numbers with - or _
      .replace(/[-_]\d+[a-zA-Z0-9]*$/, "") // Remove timestamps/hashes
      .replace(/[-_]/g, " ") // Replace underscores and dashes with spaces
      .trim();

    return categoryName;
  };

  // Function to find category by name
  const findCategoryByName = (categoryName) => {
    // Try exact match first
    let category = eventCategories.find(cat => 
      cat.name.toLowerCase() === categoryName.toLowerCase()
    );

    // If no exact match, try partial match
    if (!category) {
      category = eventCategories.find(cat => 
        cat.name.toLowerCase().includes(categoryName.toLowerCase()) ||
        categoryName.toLowerCase().includes(cat.name.toLowerCase())
      );
    }

    return category;
  };

  // Function to handle category image upload and update
  const handleUploadAndUpdateCategories = async () => {
    const fileInput = document.createElement('input');
    fileInput.type = 'file';
    fileInput.multiple = true;
    fileInput.accept = 'image/*';
    
    fileInput.onchange = async (e) => {
      const files = Array.from(e.target.files);
      if (files.length === 0) return;

      setUploadingCategories(true);
      
      try {
        // Step 1: Upload files and get IDs
        console.log('Uploading category files...', files);
        const uploadResponse = await uploadsmultipleimages_getids(files);
        console.log('Category upload response:', uploadResponse);

        if (!uploadResponse.files || uploadResponse.files.length === 0) {
          throw new Error('No files were uploaded successfully');
        }

        // Step 2: Process each uploaded file for categories
        setUpdatingCategories(true);
        const results = [];

        for (const fileData of uploadResponse.files) {
          try {
            const fileName = fileData.file_name;
            const categoryName = extractCategoryNameFromFileName(fileName);
            
            console.log(`Processing category: ${fileName} -> Looking for category: "${categoryName}"`);

            const category = findCategoryByName(categoryName);
            
            if (category) {
              console.log(`Found category: ${category.name} (ID: ${category.id})`);
              
              // Update category with image_id
              await updateEvencategoryImage(category.id, fileData.id);
              
              results.push({
                fileName,
                categoryName: category.name,
                status: 'success',
                categoryId: category.id,
                imageId: fileData.id
              });
              
              console.log(`✅ Updated category "${category.name}" with image ${fileData.id}`);
            } else {
              results.push({
                fileName,
                categoryName,
                status: 'no_match',
                categoryId: null,
                imageId: fileData.id
              });
              console.warn(`❌ No category found for: ${categoryName}`);
            }
          } catch (error) {
            results.push({
              fileName: fileData.file_name,
              categoryName: extractCategoryNameFromFileName(fileData.file_name),
              status: 'error',
              error: error.message
            });
            console.error(`Error processing category ${fileData.file_name}:`, error);
          }
        }

        // Show results summary
        const successCount = results.filter(r => r.status === 'success').length;
        const noMatchCount = results.filter(r => r.status === 'no_match').length;
        const errorCount = results.filter(r => r.status === 'error').length;

        alert(`Category Update completed!\n\n✅ Success: ${successCount}\n❌ No match: ${noMatchCount}\n🚫 Errors: ${errorCount}`);

        // Log detailed results
        console.log('Category detailed results:', results);

        // Reload categories to show updated images
        if (successCount > 0) {
          loadEventCategories();
        }

      } catch (error) {
        console.error('Category upload/update failed:', error);
        alert(`Category upload failed: ${error.message}`);
      } finally {
        setUploadingCategories(false);
        setUpdatingCategories(false);
      }
    };

    fileInput.click();
  };
  // Function to extract event name from filename
  const extractEventNameFromFileName = (fileName) => {
    // Remove file extension and any numbers/timestamps
    let eventName = fileName
      .replace(/\.[^/.]+$/, "") // Remove file extension
      .replace(/[-_]\d+$/, "") // Remove trailing numbers with - or _
      .replace(/[-_]\d+[a-zA-Z0-9]*$/, "") // Remove timestamps/hashes
      .replace(/_/g, " ") // Replace underscores with spaces
      .trim();

    return eventName;
  };

  // Function to find event by name
  const findEventByName = (eventName) => {
    // Flatten all events from all categories
    const allEvents = eventCategories.flatMap(category => category.events || []);
    
    // Try exact match first
    let event = allEvents.find(e => 
      e.name.toLowerCase() === eventName.toLowerCase()
    );

    // If no exact match, try partial match
    if (!event) {
      event = allEvents.find(e => 
        e.name.toLowerCase().includes(eventName.toLowerCase()) ||
        eventName.toLowerCase().includes(e.name.toLowerCase())
      );
    }

    return event;
  };

  // Function to update event with image_id
 

  // Main upload and update function
  const handleUploadAndUpdate = async () => {
    const fileInput = document.createElement('input');
    fileInput.type = 'file';
    fileInput.multiple = true;
    fileInput.accept = 'image/*';
    
    fileInput.onchange = async (e) => {
      const files = Array.from(e.target.files);
      if (files.length === 0) return;

      setUploading(true);
      
      try {
        // Step 1: Upload files and get IDs
        console.log('Uploading files...', files);
        const uploadResponse = await uploadsmultipleimages_getids(files);
        console.log('Upload response:', uploadResponse);

        if (!uploadResponse.files || uploadResponse.files.length === 0) {
          throw new Error('No files were uploaded successfully');
        }

        // Step 2: Process each uploaded file
        setUpdating(true);
        const results = [];

        for (const fileData of uploadResponse.files) {
          try {
            const fileName = fileData.file_name;
            const eventName = extractEventNameFromFileName(fileName);
            
            console.log(`Processing: ${fileName} -> Looking for event: "${eventName}"`);

            const event = findEventByName(eventName);
            
            if (event) {
              console.log(`Found event: ${event.name} (ID: ${event.id})`);
              
              // Update event with image_id
              await updateEventImage(event.id, fileData.id);
              
              results.push({
                fileName,
                eventName: event.name,
                status: 'success',
                eventId: event.id,
                imageId: fileData.id
              });
              
              console.log(`✅ Updated event "${event.name}" with image ${fileData.id}`);
            } else {
              results.push({
                fileName,
                eventName,
                status: 'no_match',
                eventId: null,
                imageId: fileData.id
              });
              console.warn(`❌ No event found for: ${eventName}`);
            }
          } catch (error) {
            results.push({
              fileName: fileData.file_name,
              eventName: extractEventNameFromFileName(fileData.file_name),
              status: 'error',
              error: error.message
            });
            console.error(`Error processing ${fileData.file_name}:`, error);
          }
        }

        // Show results summary
        const successCount = results.filter(r => r.status === 'success').length;
        const noMatchCount = results.filter(r => r.status === 'no_match').length;
        const errorCount = results.filter(r => r.status === 'error').length;

        alert(`Update completed!\n\n✅ Success: ${successCount}\n❌ No match: ${noMatchCount}\n🚫 Errors: ${errorCount}`);

        // Log detailed results
        console.log('Detailed results:', results);

        // Reload events to show updated images
        if (successCount > 0) {
          loadEventCategories();
        }

      } catch (error) {
        console.error('Upload/update failed:', error);
        alert(`Upload failed: ${error.message}`);
      } finally {
        setUploading(false);
        setUpdating(false);
      }
    };

    fileInput.click();
  };

  return (
    <div className="bg-white">
      <div className="p-4">
        <Sidebar />
        <div className="p-4">
          {isPending ? (
            <h1>Loading...</h1>
          ) : (
            <>
              <div className="flex justify-between items-center mb-4">
                <h1 className="text-2xl font-bold">Events</h1>
                  <div className="upload-buttons-container">
                    {/* New Category Upload Button */}
                    <button
                      onClick={handleUploadAndUpdateCategories}
                      disabled={uploadingCategories || updatingCategories}
                      className={`upload-btn category-btn ${
                        uploadingCategories || updatingCategories ? 'uploading' : ''
                      }`}
                    >
                      
                      <span className="btn-text">
                        {uploadingCategories 
                          ? 'Uploading...' 
                          : updatingCategories 
                            ? 'Updating...' 
                            : 'Upload Category Images'
                        }
                      </span>
                      {(uploadingCategories || updatingCategories) && (
                        <span className="spinner"></span>
                      )}
                    </button>
                    
                    {/* Existing Event Upload Button */}
                    <button
                      onClick={handleUploadAndUpdate}
                      disabled={uploading || updating}
                      className={`upload-btn event-btn ${
                        uploading || updating ? 'uploading' : ''
                      }`}
                    >
                      
                      <span className="btn-text">
                        {uploading 
                          ? 'Uploading...' 
                          : updating 
                            ? 'Updating...' 
                            : 'Upload Event Images'
                        }
                      </span>
                      {(uploading || updating) && (
                        <span className="spinner"></span>
                      )}
                    </button>
                  </div>
              </div>
              <EventsTable events={eventCategories} />
            </>
          )}
        </div>
      </div>
    </div>
  );
}

export default Eventsbody;